import React, { useMemo, useState } from "react";

const PieInfo = ({
  labels = [],
  values = [],
  percents = [],
  colors = [],
  top = 0,
  left = 0,
  width = 220,
  maxHeight = 150,
  total,
  placeholder = "Search",
  showSearch = true,
  showTotal = true,
  totalLabel = "Total",
  valueDisplay = "value",
}) => {
  const [query, setQuery] = useState("");
  const rows = useMemo(() => {
    const q = query.trim().toLowerCase();
    const arr = labels.map((l, i) => ({
      label: l,
      value: values[i] ?? 0,
      percent: percents[i] ?? 0,
      color: colors[i % colors.length],
      idx: i,
    }));
    if (!q) return arr;
    return arr.filter((r) => String(r.label).toLowerCase().includes(q));
  }, [labels, values, colors, query]);
  return (
    <div
      style={{
        position: "absolute",
        top,
        left,
        width,
        background: "#fff",
        border: "1px solid #e5e7eb",
        borderRadius: 8,
        boxShadow: "0 6px 18px rgba(0,0,0,0.08)",
        color: "#111827",
        zIndex: 1,
      }}
    >
      {showSearch && (
        <div
          style={{
            padding: 8,
            borderBottom: "1px solid #eee",
            display: "flex",
            gap: 6,
          }}
        >
          <input
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder={placeholder}
            style={{
              flex: 1,
              padding: "6px 8px",
              border: "1px solid #d1d5db",
              borderRadius: 6,
              fontSize: 12,
            }}
          />
        </div>
      )}
      <div
        style={{
          maxHeight,
          overflow: "auto",
          padding: 8,
          display: "grid",
          gap: 6,
        }}
      >
        {rows.map((r) => (
          <div
            key={`row-${r.idx}`}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: 8,
              fontSize: 12,
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <span
                style={{
                  width: 10,
                  height: 10,
                  borderRadius: 2,
                  background: r.color,
                  display: "inline-block",
                }}
              />
              <span
                style={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {r.label}
              </span>
            </div>
            <span>
              {valueDisplay === "percentage"
                ? `${Math.round(r.percent)}%`
                : valueDisplay === "value_percentage"
                ? `${String(r.value)} / ${Math.round(r.percent)}%`
                : String(r.value)}
            </span>
          </div>
        ))}
      </div>
      {showTotal && (
        <div
          style={{ padding: 8, borderTop: "1px solid #e5e7eb", display: "flex" }}
        >
          <span style={{ opacity: 0.7 }}>{totalLabel}</span>
          <span style={{ marginLeft: "auto" }}>
            {valueDisplay === "percentage" ? "100%" : String(total)}
          </span>
        </div>
      )}
    </div>
  );
};

export default PieInfo;
